import React from "react";
import { Link } from "react-router-dom";

export const Data = [
  {
    title: "Matrices",
    desc: "Introduction to Matrices.",
    url: "/matrices",
  },
  {
    title: "Determinants",
    desc: "Introduction  to  Determinants.",
    url: "/determinants",
  },
];

export default function Card(props) {
  return (
    <div className="container mx-4 my-16 lg:mx-44">
      <div className="max-w-xs rounded overflow-hidden shadow-lg">
        <div className="px-2 font-bold text-frost-green text-3xl mb-2">
          {props.title}
        </div>
        <div className="px-2 text-aurora-orange text-xl font-semibold">
          {props.desc}
        </div>
        <div className="px-2 py-1.5">
          <Link
            to={props.url}
            className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-frost-blue hover:bg-opacity-80 md:py-4 md:text-lg md:px-10"
          >
            <button> Visit Now </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
